import { render, staticRenderFns } from "./ListInvoicePage.vue?vue&type=template&id=9235cfee&"
import script from "./ListInvoicePage.vue?vue&type=script&lang=js&"
export * from "./ListInvoicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports